import { AppRegistrationSection } from './AppRegistrationSection';
import { BasicFrameConfig, RegistrationFrameConfig } from 'InternalLibrary';
import {
  CalculatorDesktop,
  CalculatorMobile,
} from './components/Calculator/Calculator';
import { DEFAULT_TERM, IS_VIVUS, PHONE, URL_PATH } from 'utils/constants';
import { Logo, LogoSquare } from 'components/icons';
import { logout } from './actions/logout';
import { Navbar } from './components/Navbar/Navbar';
import { Panel } from './components/Panel/Panel';
import i18n from 'i18next';

export interface AppConfig {
  term?: number; // Loan duration in days - when defined, the loan duration is fixed
  age: { min: number; max: number };
  productNumber: string;
  productKind: string;
  phoneCountryCode: string;
  phoneNumber: string;
  email: string;
  businessHours: string;
  originUrl: string;
  formatting: {
    nbspSymbol: string;
    numberDelimeter: string;
    numberGroupSize: number;
    defaultDateFormat: string;
  };
  fallbackTerm: number;
  fallbackAmount: number;
  // frame
  frameConfig: RegistrationFrameConfig;
  frameConfigBasic: BasicFrameConfig;
  frameConfigBasicAffiliateFlow: BasicFrameConfig;
}

export const frameConfigBasic: BasicFrameConfig = {
  logoSquare: <LogoSquare />,
  logo: <Logo />,
  frameContent: {
    logout: i18n.t('common:logout'),
    goBack: i18n.t('common:goBack'),
    contactEmail: i18n.t('common:contactEmail'),
    contactPhone: i18n.t('common:contactPhone'),
    businessHours: i18n.t('common:businessHours'),
    termsAndConditionsText: i18n.t('common:termsAndConditionsText'),
    termsAndConditionsUrl: i18n.t('common:termsAndConditionsUrl'),
  },
  onLogoutButtonClick: () => logout(),
};

export const frameConfigBasicTink: AppConfig['frameConfig'] = {
  logoSquare: <LogoSquare />,
  logo: <Logo />,
  frameContent: {
    logout: i18n.t('common:logout'),
    goBack: i18n.t('common:goBack'),
    contactEmail: i18n.t('common:contactEmail'),
    contactPhone: i18n.t('common:contactPhone'),
    businessHours: i18n.t('common:businessHours'),
    termsAndConditionsText: i18n.t('common:termsAndConditionsText'),
    termsAndConditionsUrl: i18n.t('common:termsAndConditionsUrl'),
  },
  onLogoutButtonClick: () => logout(),
  navbar: Navbar,
};

export const frameConfigBasicAffiliateFlow: BasicFrameConfig = {
  ...frameConfigBasic,
  headerLayout: 'centered',
  footerLayout: 'default',
};

export const frameConfig: AppConfig['frameConfig'] = {
  ...frameConfigBasic,
  calculatorDesktop: CalculatorDesktop,
  calculatorMobile: CalculatorMobile,
  navbar: Navbar,
  panel: Panel,
  sections: [
    {
      id: AppRegistrationSection.Intro,
      title: i18n.t('progress:intro'),
    },
    {
      id: AppRegistrationSection.Identification,
      title: i18n.t('progress:identification'),
    },
    {
      id: AppRegistrationSection.Confirmation,
      title: i18n.t('progress:confirmation'),
    },
    {
      id: AppRegistrationSection.Summary,
      title: i18n.t('progress:summary'),
    },
  ],
};

export const config: AppConfig = {
  originUrl: URL_PATH,
  frameConfig,
  frameConfigBasic,
  frameConfigBasicAffiliateFlow,
  age: { max: 79, min: 21 },
  productNumber: IS_VIVUS ? '8' : '6',
  productKind: IS_VIVUS ? 'VIVUS_SPL' : 'VIVUS_ONLINE',
  phoneCountryCode: '+34',
  phoneNumber: i18n.t('common:contactPhone') || PHONE,
  email: i18n.t('common:contactEmail'),
  businessHours: i18n.t('common:businessHours'),
  formatting: {
    nbspSymbol: '\xa0',
    numberDelimeter: ',',
    numberGroupSize: 3,
    defaultDateFormat: 'DD.MM.YYYY',
  },
  fallbackTerm: DEFAULT_TERM,
  term: DEFAULT_TERM,
  fallbackAmount: 300,
};
